import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Input } from "reactstrap";

/**
 * Input de contraseña con un ojo dentro del campo para mostrar u ocultar el
 * texto. Recibe las mismas props que `Input` de reactstrap; `children` se
 * coloca después del campo (por ejemplo, un `FormFeedback`).
 * Estilos globales en scss/dhn/_password-input.scss.
 *
 * <PasswordInput value={password} onChange={onChange} />
 */
export default function PasswordInput({ children, className, disabled, ...inputProps }) {
  const [isVisible, setIsVisible] = useState(false);
  const label = isVisible ? "Ocultar contraseña" : "Mostrar contraseña";

  return (
    <div className={classnames("dhn-password-input", className)}>
      <Input {...inputProps} disabled={disabled} type={isVisible ? "text" : "password"} />
      <button
        type="button"
        className="dhn-password-input__toggle"
        title={label}
        aria-label={label}
        aria-pressed={isVisible}
        disabled={disabled}
        onClick={() => setIsVisible((visible) => !visible)}
      >
        <i className={classnames("fa", isVisible ? "fa-eye-slash" : "fa-eye")} aria-hidden="true"></i>
      </button>
      {children}
    </div>
  );
}

PasswordInput.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

PasswordInput.defaultProps = {
  disabled: false,
};
